import { fetch } from "../lib/network";
import AppSettings from "../config";

export const REQUEST_CASES = "REQUEST_CASES";
export const RECEIVE_CASES = "RECEIVE_CASES";

function requestCases(filterId) {
  return {
    type: REQUEST_CASES,
    filterId,
  };
}

function receiveCases(filterId, json) {
  return {
    type: RECEIVE_CASES,
    filterId,
    cases: json.data,
    receivedAt: Date.now(),
  };
}

function fetchCases(filterId) {
  return (dispatch) => {
    dispatch(requestCases(filterId));
    let options = {
      credentials: "include",
    };
    return fetch(`${AppSettings.GOGOV_WEB_API_URL}/api/filter_map.php?filterid=${filterId}`, options)
      .then((response) => response.json())
      .then((json) => dispatch(receiveCases(filterId, json)));
  };
}

function shouldFetchCases(state, filterId) {
  const cases = state.casesByFilter[filterId];
  if (!cases) {
    return true;
  } else if (cases.isFetching) {
    return false;
  } else {
    return cases.didInvalidate;
  }
}

export function fetchCasesIfNeeded(filterId) {
  return (dispatch, getState) => {
    if (shouldFetchCases(getState(), filterId)) {
      return dispatch(fetchCases(filterId));
    }
  };
}
